
const config = {

  apiBaseUrl: "https://backend.aromaagrotech.com/api",

  // apiBaseUrl: "http://localhost:2026/api",

  adminLogin: "admin/auth/login",
  changePassword: "admin/auth/change-password",
  forgotPassword: "admin/auth/forgot-password",
  createAdmin: "admin/auth/create",

  getAdmin: "admin/get",
  getAdminById: "admin/get",
  deleteAdmin: "admin/delete",

  dashboardAnalytics: "dashboard/dashboard-analytics",
  ivrDashboardManual: "dashboard/ivr-dashboard-manual",
  marketReportDashboard: "dashboard/market-report-dashboard",
  marketReportDashboardFilters: "dashboard/market-report-dashboard/filters",
  ivrDashboardCounts: "dashboard/ivr-dashboard-counts",
  ivrDashboardAnalytics: "dashboard/ivr-dashboard-analytics",
  ivrDashboardManualV2: "dashboard/v2/ivr-dashboard-manual",

  triggerIVRCalling: "campaign-call/trigger-ivr-calling",
  completedIVRCalls: "campaign-call/completed-ivr-calls",
  ivrStatusById: "campaign-call/ivr-status",
  fixVarieties: "campaign-call/fix-varieties",
  triggerSurvey: "campaign-call/trigger-survey",
  manualIVRForm: "campaign-call/manual-ivr-form",

  getMarketReports: "market-survey/get",
  createMarketReport: "market-survey/create",
  reportDateAvailable: "market-survey/report-date-available",
  deleteAllMarketReports: "market-survey/delete-all",

  fileValidationLogs: "market-survey/file-validation-logs",
  fixFileValidationCallDate: "market-survey/fix-file--validation-call-date",
  deleteFileValidationLogs: "market-survey/delete-file-validation-logs",
  deleteFileFailCall: "market-survey/delete-file-fail-call",
  deleteFileValidationLog: "market-survey/delete-log",

  createMandiPartner: "mandi-partner/create",
  getAllMandiPartners: "mandi-partner/get-all",
  updateMandiPartner: "mandi-partner/update",
  deleteMandiPartner: "mandi-partner/delete",
  bulkCreateMandiPartner: "mandi-partner/bulk-create",
  getIVRMandiPartners: "mandi-partner/get-ivr-partners",
  getPartnersByCode: "mandi-partner/get-partners-by-code",
};

export default config;

